/** The app's own terminal palette (xterm requires concrete sRGB values); a code theme's terminal
 * colors replace it (see `AppearanceProvider`). */
export const TERMINAL_THEME = {
  background: '#0d1218',
  foreground: '#d6dce5',
  cursor: '#d6dce5',
  selectionBackground: '#334155aa',
  black: '#1f2937',
  red: '#f87171',
  green: '#4ade80',
  yellow: '#facc15',
  blue: '#60a5fa',
  magenta: '#c084fc',
  cyan: '#22d3ee',
  white: '#e5e7eb',
  brightBlack: '#6b7280',
  brightRed: '#fca5a5',
  brightGreen: '#86efac',
  brightYellow: '#fde047',
  brightBlue: '#93c5fd',
  brightMagenta: '#d8b4fe',
  brightCyan: '#67e8f9',
  brightWhite: '#ffffff',
} as const;
